<div class="header-bar">
  <h1>System Configuration</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <form #form="ngForm">
        <p-accordion>
          <p-accordionTab header="Send Support Mails To" [selected]>
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <label
                  for="EmailAddress1"
                  class="ui-grid-col-4 control-label"
                  style="
                    text-align: right;
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 20px;
                  "
                  >Address 1:</label
                >
                <div class="label-content ui-grid-col-5">
                  <input
                    id="EmailAddress1"
                    name="EmailAddress1"
                    type="email"
                    class="form-control"
                    [(ngModel)]="Settings.support.emailAddress1"
                    placeholder="issue-bbwt@pts.bbconsult.co.uk"
                    pInputText
                    #email="ngModel"
                  />
                </div>
              </div>

              <div class="ui-grid-row" style="margin-bottom: 10px">
                <label
                  for="EmailAddress2"
                  class="ui-grid-col-4 control-label"
                  style="
                    text-align: right;
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 20px;
                  "
                  >Address 2:</label
                >
                <div class="label-content ui-grid-col-5">
                  <input
                    id="EmailAddress2"
                    name="EmailAddress2"
                    type="email"
                    class="form-control"
                    [(ngModel)]="Settings.support.emailAddress2"
                    pInputText
                    #email="ngModel"
                  />
                </div>
              </div>

              <div class="ui-grid-row" style="margin-bottom: 10px">
                <label
                  for="EmailAddress3"
                  class="ui-grid-col-4 control-label"
                  style="
                    text-align: right;
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 20px;
                  "
                  >Address 3:</label
                >
                <div class="label-content ui-grid-col-5">
                  <input
                    id="EmailAddress3"
                    name="EmailAddress3"
                    type="email"
                    class="form-control"
                    [(ngModel)]="Settings.support.emailAddress3"
                    pInputText
                    #email="ngModel"
                  />
                </div>
              </div>

              <div class="ui-grid-row" style="margin-bottom: 10px">
                <label
                  for="EmailAddress4"
                  class="ui-grid-col-4 control-label"
                  style="
                    text-align: right;
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 20px;
                  "
                  >Address 4:</label
                >
                <div class="label-content ui-grid-col-5">
                  <input
                    id="EmailAddress4"
                    name="EmailAddress4"
                    type="email"
                    class="form-control"
                    [(ngModel)]="Settings.support.emailAddress4"
                    pInputText
                    #email="ngModel"
                  />
                </div>
              </div>
            </div>
          </p-accordionTab>

          <p-accordionTab header="Maintenance">
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <label
                  class="ui-grid-col-4 control-label"
                  style="text-align: right; margin-right: 20px"
                  >Options:</label
                >
                <div class="label-content ui-grid-col-8">
                  <p-radioButton
                    name="maintenanceOptionsGrp"
                    value="0"
                    [(ngModel)]="Settings.maintenanceSettings.option"
                  ></p-radioButton>
                  <label>Basic</label>
                </div>
              </div>
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <div class="ui-grid-col-4" style="margin-right: 20px"></div>
                <div class="label-content ui-grid-col-8">
                  <p-radioButton
                    name="maintenanceOptionsGrp"
                    value="1"
                    [(ngModel)]="Settings.maintenanceSettings.option"
                  ></p-radioButton>
                  <label>External</label>
                </div>
              </div>

              <div
                class="ui-grid-row"
                *ngIf="Settings.maintenanceSettings.option == 0"
                style="margin-bottom: 10px"
              >
                <label class="ui-grid-col-4" style="margin-right: 20px"></label>
                <div class="label-content ui-grid-col-5">
                  <p-checkbox
                    id="maintenanceEnabled"
                    name="maintenanceEnabled"
                    label="Enabled"
                    binary="true"
                    [(ngModel)]="Settings.maintenanceSettings.isActive"
                  ></p-checkbox>
                </div>
              </div>

              <div *ngIf="Settings.maintenanceSettings.isActive">
                <div
                  class="ui-grid-row"
                  *ngIf="Settings.maintenanceSettings.option == 0"
                  style="margin-bottom: 10px; margin-top: 25px"
                >
                  <label
                    for="maintenanceStart"
                    class="ui-grid-col-4 control-label"
                    style="
                      text-align: right;
                      margin-top: auto;
                      margin-bottom: auto;
                      margin-right: 20px;
                    "
                    >Start:</label
                  >
                  <div class="label-content ui-grid-col-5">
                    <p-calendar
                      id="maintenanceStart"
                      name="maintenanceStart"
                      [minDate]="currentDate"
                      [showTime]="true"
                      [(ngModel)]="Settings.maintenanceSettings.start"
                      (onSelect)="OnChangeMaintenanceStart($event)"
                      required
                    ></p-calendar>
                  </div>
                </div>
                <div
                  class="ui-grid-row"
                  *ngIf="Settings.maintenanceSettings.option == 0"
                  style="margin-bottom: 10px"
                >
                  <label
                    for="maintenanceEnd"
                    class="ui-grid-col-4 control-label"
                    style="
                      text-align: right;
                      margin-top: auto;
                      margin-bottom: auto;
                      margin-right: 20px;
                    "
                    >End:</label
                  >
                  <div class="label-content ui-grid-col-5">
                    <p-calendar
                      id="maintenanceEnd"
                      name="maintenanceEnd"
                      [minDate]="Settings.maintenanceSettings.start"
                      [showTime]="true"
                      [(ngModel)]="Settings.maintenanceSettings.end"
                      required
                    ></p-calendar>
                  </div>
                </div>
                <div
                  class="ui-grid-row"
                  *ngIf="Settings.maintenanceSettings.option == 0"
                  style="margin-bottom: 10px"
                >
                  <label
                    for="maintenanceMessage"
                    class="ui-grid-col-4 control-label"
                    style="
                      text-align: right;
                      margin-top: auto;
                      margin-bottom: auto;
                      margin-right: 20px;
                    "
                    >Message:</label
                  >
                  <div class="label-content ui-grid-col-5">
                    <input
                      id="maintenanceMessage"
                      name="maintenanceMessage"
                      type="text"
                      pInputText
                      [(ngModel)]="Settings.maintenanceSettings.message"
                    />
                  </div>
                </div>
              </div>

              <div
                class="ui-grid-row"
                *ngIf="Settings.maintenanceSettings.option == 1"
                style="margin-bottom: 10px; margin-top: 25px"
              >
                <label
                  for="maintenanceExternalApiUrl"
                  class="ui-grid-col-4 control-label"
                  style="
                    text-align: right;
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 20px;
                  "
                  >External API Url:</label
                >
                <div class="label-content ui-grid-col-5">
                  <input
                    id="maintenanceExternalApiUrl"
                    name="maintenanceExternalApiUrl"
                    type="url"
                    class="form-control"
                    [(ngModel)]="Settings.maintenanceSettings.externalApiUrl"
                    pInputText
                    required
                  />
                </div>
              </div>
            </div>
          </p-accordionTab>

          <p-accordionTab header="System Settings">
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <system-settings></system-settings>
              </div>
            </div>
          </p-accordionTab>

          <p-accordionTab header="Payments (Revolut)">
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <div class="ui-grid-col-3 mt-1">
                  <button
                    type="button"
                    (click)="setRevolutWebhook()"
                    label="Set Up Revolut Webhook"
                    pButton
                  ></button>
                </div>

                <div class="ui-md-offset-2 ui-grid-col-3 mt-1">
                  <button
                    type="button"
                    (click)="openRevolutAuthorizationUrl()"
                    label="Request Revolut Authorization Code"
                    pButton
                  ></button>
                </div>

                <div class="ui-md-offset-2 ui-grid-col-3 mt-1">
                  <button
                    type="button"
                    (click)="resetRevolutAccessCodes()"
                    label="Reset Access Codes"
                    pButton
                  ></button>
                </div>
              </div>
            </div>
          </p-accordionTab>
          <p-accordionTab header="Xero">
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-row" style="margin-bottom: 10px">
                <xero-settings></xero-settings>
              </div>
            </div>
          </p-accordionTab>
          <p-accordionTab header="Hangfire">
            <hangfire-settings></hangfire-settings>
          </p-accordionTab>
          <p-accordionTab header="Hangfire (AWS ECS Manager)">
            <app-hangfire-ecs-manager></app-hangfire-ecs-manager>
          </p-accordionTab>
        </p-accordion>

        <div class="card mt-5">
          <div class="card-body">
            <div *ngIf="!!versionInformation">
              <div class="row g-2">
                <div class="col-12">Product Version: {{ versionInformation.productVersion }}</div>
                <div class="col-12">File Version: {{ versionInformation.fileVersion }}</div>
                <div class="col-12">Pipeline: {{ versionInformation.pipeline }}</div>
                <div class="col-12">Build Commit: {{ versionInformation.buildCommitHash }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-5">
          <!--Render System Date Information-->
          <div class="col-12" *ngIf="!!systemDateTimeInfo">
            <div class="col-12">Local: {{ systemDateTimeInfo.local }}</div>
            <div class="col-12">UTC: {{ systemDateTimeInfo.utc }}</div>
            <div class="col-12">Current Culture: {{ systemDateTimeInfo.culture }}</div>
            <div class="col-12">Current Timezone: {{ systemDateTimeInfo.timeZone }}</div>
          </div>

          <div style="margin-top: 10px">
            <button
              pButton
              type="button"
              [disabled]="!form.dirty || form.invalid"
              (click)="Save()"
              label="Save"
            ></button>
            <button
              pButton
              type="button"
              [disabled]="!form.dirty"
              (click)="Reset()"
              label="Reset"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  key="modify-revolut-access-keys-dialog"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
